import { useEffect, useRef } from "react";
import { NavLink, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import $ from 'jquery';
import FeedbackModal from "../feedback-modal";
import { hideLoader, showLoader } from "../loader";
import { useRouteMatch } from "react-router-dom/cjs/react-router-dom";
import { apiUrl } from "../../utils/url";

const CampaignHeader = ({setActiveBlock,productData, editProduct }) => {
    let { url } = useRouteMatch();
    const { basePath,slug } = useSelector(state => state?.slugReducer);
    const history = useHistory();
    const [showFeedbackModal, setShowFeedbackModal] = useState(false);
    const [productsList, setProductsList] = useState([]);
    const campaignsList = useSelector(state => state?.campgignsListReducer);
    const openHubSpotChat = (e) => {
        e.stopPropagation();
        if(!document.getElementById('hubspot-conversations-iframe')){
            showLoader();
            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.id = 'hs-script-loader';
            script.async = true;
            script.defer = true;
            script.src = '//js-na1.hs-scripts.com/46190671.js';
            document.body.appendChild(script);
            script.onload = () => {
                const checkWidgetInterval = setInterval(() => {
                    if (window?.HubSpotConversations) {
                        clearInterval(checkWidgetInterval);
                        // window.HubSpotConversations.resetAndReloadWidget();
                        window.HubSpotConversations.widget?.open();
                        window?.HubSpotConversations?.on('widgetClosed', handleDropdownHide);
                        if(document.getElementById('hubspot-conversations-iframe')){
                            hideLoader();
                        }
                    }
                }, 500);
            };
        }else {
            if (window?.HubSpotConversations) {
                var iframe = document.getElementById('hubspot-conversations-iframe')
                window.HubSpotConversations.widget?.open();
                iframe.style.setProperty('display', 'initial', 'important');
            }
        }
    };
    const moveBack = () => {
        history.push(basePath + '/campaigns');
    };
    const getProductList = () => {
        showLoader();
        var myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${localStorage?.getItem("token")}`);
        var requestOptions = {
            method: 'GET',
            headers: myHeaders
        };
        fetch(apiUrl + `/ProductFlow/list/${slug}`, requestOptions)
            .then(async (res) => {
                const response = await res?.json();

                if (response?.status_code == 200) {
                    setProductsList(response?.data?.filter(product => product.id !== productData.id));
                    hideLoader();
                }

            }).catch((err) => {
                hideLoader();
            })

    };
    useEffect(()=>{
        if(productData?.id){
            if(campaignsList?.length > 0){
                setProductsList(campaignsList.filter(product => product.id !== productData.id));
            }else{
                getProductList();
            }
        }

    },[productData?.id])
    // useEffect(() => {
    //     if (slug && productsList.length == 0) {
    //         getProductList();
    //     }
    // }, [slug]);
    const selectOptionClick = (id) => {
        const currentPath = window.location.pathname;
        const currentSearch = window.location.search; // This gets the query string
        const pathParts = currentPath.split('/');
        
        // Assuming the campaign ID is always the second-to-last part of the URL
        pathParts[pathParts.length - 2] = id;
        
        const newPath = pathParts.join('/');
        
        history.push(newPath + currentSearch);
        editProduct(id);
        // history.go();
    };
    return (
        <>
            <header className="hidden-scroll d-flex align-items-center justify-content-between" onClick={() => setActiveBlock({name:'template_settings',id:productData?.id,data:{productData}})}>
                <div className="d-inline-flex gap-2 align-items-center">
                <div className="header-dropdown-main">
                    <div className="header-dropdown me-2" onClick={() => moveBack()} id="header-dropdown"  style={{ boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.12)" }}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="6" height="9" viewBox="0 0 6 9" fill="none">
                            <path d="M5.66087 8.68483C5.2087 9.10506 4.47558 9.10506 4.02341 8.68483L0.33913 5.26085C-0.113042 4.84062 -0.113043 4.1593 0.339129 3.73908C0.791301 3.31886 1.52442 3.31885 1.97659 3.73908L5.66087 7.16306C6.11304 7.58329 6.11304 8.26461 5.66087 8.68483Z" fill="#999999" />
                            <path d="M0.33913 5.26085C-0.113042 4.84062 -0.113043 4.1593 0.339129 3.73908L4.02285 0.315169C4.47502 -0.105056 5.20814 -0.105056 5.66031 0.315169C6.11248 0.735393 6.11248 1.41671 5.66031 1.83694L1.97603 5.26092C1.52385 5.68114 0.791301 5.68107 0.33913 5.26085Z" fill="#999999" />
                        </svg>
                    </div>
                </div>
                <span className="campaign-switcher-dropdown noselect" id="campaign-switch" data-bs-toggle="dropdown" aria-expanded="false" >
                    <span className="text-truncate">{productData?.name}</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="7" height="4" viewBox="0 0 7 4" fill="none">
                        <path d="M6.75487 0.226086C7.08171 0.527534 7.08171 1.01628 6.75487 1.31773L4.09177 3.77391C3.76493 4.07536 3.23502 4.07536 2.90817 3.77391C2.58133 3.47247 2.58133 2.98372 2.90817 2.68227L5.57127 0.226086C5.89811 -0.0753619 6.42803 -0.075362 6.75487 0.226086Z" fill="#333333"/>
                        <path d="M4.09177 3.77391C3.76493 4.07536 3.23502 4.07536 2.90817 3.77391L0.245131 1.3181C-0.0817103 1.01665 -0.0817105 0.527908 0.245131 0.226461C0.571973 -0.0749871 1.10189 -0.0749873 1.42873 0.22646L4.09183 2.68265C4.41867 2.9841 4.41861 3.47247 4.09177 3.77391Z" fill="#333333"/>
                    </svg>
                </span>
                <ul class="campaign-switcher-dropdown-item-menu dropdown-menu" aria-labelledby="campaign-switch">
                {productsList?.length > 0 && productsList?.map((val, index) => <li key={index} onClick={() => selectOptionClick(val?.id)}  class="campaign-switcher-dropdown-item" >{val.name}</li>)}
                </ul>
                </div>
                <div className="campaign-tabs-main">
                    <NavLink to={`${url}/leads`} activeClassName="active" className="campaign-tab">
                        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="14" viewBox="0 0 13 14" fill="none">
                            <path d="M12 13C12 12.0696 12 11.6044 11.8816 11.2259C11.615 10.3736 10.9272 9.70669 10.0483 9.44816C9.65793 9.33333 9.1782 9.33333 8.21875 9.33333H4.78125C3.8218 9.33333 3.34207 9.33333 2.95171 9.44816C2.07281 9.70669 1.38503 10.3736 1.11841 11.2259C1 11.6044 1 12.0696 1 13M9.59375 4C9.59375 5.65685 8.20863 7 6.5 7C4.79137 7 3.40625 5.65685 3.40625 4C3.40625 2.34315 4.79137 1 6.5 1C8.20863 1 9.59375 2.34315 9.59375 4Z" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        <span>
                            Leads
                        </span>
                    </NavLink>
                    <NavLink to={`${url}/template`} activeClassName="active" className="campaign-tab">
                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="16" viewBox="0 0 15 16" fill="none">
                            <path d="M13.6389 4.64614L7.49998 7.99998M7.49998 7.99998L1.36109 4.64614M7.49998 7.99998L7.5 14.7471M14 10.8825V5.11752C14 4.87416 14 4.75249 13.9635 4.64396C13.9313 4.54796 13.8786 4.45983 13.8089 4.38548C13.7301 4.30143 13.622 4.24234 13.4056 4.12416L8.06119 1.20435C7.85636 1.09245 7.75395 1.0365 7.64549 1.01456C7.5495 0.995146 7.4505 0.995146 7.35451 1.01456C7.24605 1.0365 7.14364 1.09245 6.93881 1.20435L1.59437 4.12416C1.37805 4.24234 1.26988 4.30144 1.19112 4.38548C1.12145 4.45983 1.06872 4.54796 1.03646 4.64397C1 4.75249 1 4.87416 1 5.11752V10.8825C1 11.1258 1 11.2475 1.03646 11.356C1.06872 11.452 1.12145 11.5402 1.19112 11.6145C1.26988 11.6986 1.37805 11.7577 1.59437 11.8758L6.93881 14.7957C7.14364 14.9076 7.24605 14.9635 7.35451 14.9854C7.4505 15.0049 7.5495 15.0049 7.64549 14.9854C7.75395 14.9635 7.85636 14.9076 8.06119 14.7957L13.4056 11.8758C13.622 11.7577 13.7301 11.6986 13.8089 11.6145C13.8786 11.5402 13.9313 11.452 13.9635 11.356C14 11.2475 14 11.1258 14 10.8825Z" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        Template
                    </NavLink>
                    <NavLink to={`${url}/generate`} activeClassName="active" className="campaign-tab">
                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="16" viewBox="0 0 15 16" fill="none">
                            <path d="M11.725 5.4V2.15M3.275 13.85V10.6M10.1 3.775H13.35M1.65 12.225H4.9M3.925 1.5L3.4151 2.5198C3.24253 2.86493 3.15625 3.0375 3.04098 3.18704C2.9387 3.31974 2.81974 3.4387 2.68704 3.54098C2.5375 3.65625 2.36493 3.74253 2.0198 3.9151L1 4.425L2.0198 4.9349C2.36493 5.10747 2.5375 5.19375 2.68704 5.30902C2.81974 5.4113 2.9387 5.53026 3.04098 5.66296C3.15625 5.8125 3.24253 5.98507 3.4151 6.3302L3.925 7.35L4.4349 6.3302C4.60747 5.98507 4.69375 5.8125 4.80902 5.66296C4.9113 5.53026 5.03026 5.4113 5.16296 5.30902C5.3125 5.19375 5.48507 5.10747 5.8302 4.9349L6.85 4.425L5.8302 3.9151C5.48507 3.74253 5.3125 3.65625 5.16296 3.54098C5.03026 3.4387 4.9113 3.31974 4.80902 3.18704C4.69375 3.0375 4.60747 2.86493 4.4349 2.5198L3.925 1.5ZM10.75 8L10.1318 9.23646C9.9592 9.5816 9.87292 9.75417 9.75765 9.90371C9.65536 10.0364 9.5364 10.1554 9.40371 10.2576C9.25417 10.3729 9.0816 10.4592 8.73646 10.6318L7.5 11.25L8.73646 11.8682C9.0816 12.0408 9.25417 12.1271 9.40371 12.2424C9.5364 12.3446 9.65536 12.4636 9.75765 12.5963C9.87292 12.7458 9.9592 12.9184 10.1318 13.2635L10.75 14.5L11.3682 13.2635C11.5408 12.9184 11.6271 12.7458 11.7424 12.5963C11.8446 12.4636 11.9636 12.3446 12.0963 12.2424C12.2458 12.1271 12.4184 12.0408 12.7635 11.8682L14 11.25L12.7635 10.6318C12.4184 10.4592 12.2458 10.3729 12.0963 10.2576C11.9636 10.1554 11.8446 10.0364 11.7424 9.90371C11.6271 9.75417 11.5408 9.5816 11.3682 9.23646L10.75 8Z" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        Generate
                    </NavLink>
                    <NavLink to={`${url}/analytics`} activeClassName="active" className="campaign-tab">
                        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="12" viewBox="0 0 10 12" fill="none">
                            <path d="M9 11V4.75M5 11V1M1 11V7.25" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        Analytics
                    </NavLink>
                </div>
                <div className="d-flex align-items-center">

                    <div className={`top-header-link header-link `} id="header-help-dropdown" data-bs-toggle="dropdown" aria-expanded="false">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                            <path d="M5.254 5.2C5.39506 4.799 5.67349 4.46086 6.03997 4.24548C6.40645 4.0301 6.83734 3.95136 7.25631 4.02323C7.67527 4.09509 8.05529 4.31291 8.32905 4.63812C8.6028 4.96332 8.75263 5.37491 8.752 5.8C8.752 7 6.952 7.6 6.952 7.6M7 10H7.006M13 7C13 10.3137 10.3137 13 7 13C3.68629 13 1 10.3137 1 7C1 3.68629 3.68629 1 7 1C10.3137 1 13 3.68629 13 7Z" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        Help
                    </div>
                    <ul className="filter-dropdown-menu help-dropdown-menu dropdown-menu" aria-labelledby="header-help-dropdown">
                        <li className="filter-dropdown-item" onClick={() => window.open('mailto:team@genpage.ai')}>Contact Support</li>
                        <li className="filter-dropdown-item" onClick={() => { setShowFeedbackModal(true) }}>Share Feedback</li>
                        <li className="filter-dropdown-item "><a className="text-decoration-none text-dark w-100 p-0" href="https://genpage.ai/support">Support center</a></li>
                    </ul>
                </div>
            </header>

            {showFeedbackModal && <FeedbackModal show={showFeedbackModal} setShow={setShowFeedbackModal} />}
            {/* {accountsModalOpen && <Accounts accountsModalOpen={accountsModalOpen} />} */}
        </>
    )
};

export default CampaignHeader;